<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path d="M13.2,3l-1.6.4L13.1,0,3,3.7l.5,4.4-.9.9,2.8,6.9,5.9-2.2,2-4.8-.9-.8.7-5.2Z"/>
  </svg>
</template>
